import { breakpoints, colors, fonts } from '../styles';
import React, { useState } from 'react';
import reactStringReplace from 'react-string-replace';
import styled from 'styled-components';
import { globalColor } from '../utils/globals';

interface QuestionTextProps {
    questionPhrase: string;
    questionDomain: string;
    questionDomainExplanation: string;
    shoudShowTooltip?: boolean;
    shouldShowQuestionPhrase?: boolean;
}

interface QuestionDomainProps {
    questionDomain: string;
    mouseAction: (arg0: boolean) => void;
    shoudShowTooltip?: boolean;
}

const ExplanationPopup = styled.div`
    color: ${colors.white};
    background-color: ${colors.black};
    box-sizing: border-box;
    padding: 15px;
    border-radius: 3px;
    position: fixed;
    width: 50%;
    max-width: 500px;
    left: 34%; /* Center it in the left content area */
    transform: translateX(-50%);
    margin-left: 20px;
    z-index: 9999;
    font-size: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    
    /* Reduce empty space for large content */
    max-height: 90vh;
    overflow-y: auto;
    
    /* Reduced top position */
    top: 5%;
    bottom: auto;
    
    ${breakpoints.onlyMobile} {
        width: 80%;
        font-size: 12px;
        left: 40%;
    }
`;

const QuestionPhrase = styled.div``;

interface QuestionDomainCSSProps {
    shouldUnderline: boolean;
}

const QuestionDomain = styled.span<QuestionDomainCSSProps>`
    text-decoration: ${(props) =>
        props.shouldUnderline ? 'underline' : 'inherit'};
    font-weight: bold;
    color: ${_ => globalColor.skillColor};
`;

const QuestionDomainElement: React.FC<QuestionDomainProps> = ({
    questionDomain,
    mouseAction,
    shoudShowTooltip = true,
}) => {
    return (
        <QuestionDomain
            shouldUnderline={shoudShowTooltip}
            onMouseOver={() => mouseAction(true)}
            onMouseOut={() => mouseAction(false)}
            dangerouslySetInnerHTML={{
                __html: questionDomain,
            }}
        />
    );
};

const QuestionText: React.FC<QuestionTextProps> = ({
    questionPhrase,
    questionDomain,
    questionDomainExplanation,
    shoudShowTooltip = true,
    shouldShowQuestionPhrase = true,
}) => {
    const [isShown, setIsShown] = useState(false);
    return (
        <React.Fragment>
            {shouldShowQuestionPhrase ? (
                <QuestionPhrase>
                    {reactStringReplace(
                        questionPhrase,
                        '<DOMAIN>',
                        (match, i) => {
                            return (
                                <QuestionDomainElement
                                    key={i}
                                    questionDomain={questionDomain}
                                    shoudShowTooltip={shoudShowTooltip}
                                    mouseAction={setIsShown}
                                />
                            );
                        },
                    )}
                    <span>?</span>
                </QuestionPhrase>
            ) : (
                <QuestionPhrase>
                    {
                        <QuestionDomainElement
                            key={questionPhrase}
                            questionDomain={questionDomain}
                            shoudShowTooltip={shoudShowTooltip}
                            mouseAction={setIsShown}
                        />
                    }
                </QuestionPhrase>
            )}
            {isShown && shoudShowTooltip && (
                <ExplanationPopup
                    onMouseEnter={() => setIsShown(true)}
                    onMouseOut={() => setIsShown(false)}
                    dangerouslySetInnerHTML={{
                        __html: questionDomainExplanation,
                    }}
                />
            )}
        </React.Fragment>
    );
};

export default QuestionText;